import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { questionTableCellChange } from "@learningblocks/simulations/shared-components/lib/Questions/QuestionTableRedux/store/actions";
import { Row } from "./Table";

type Table = {
  rows: Row[];
};

export interface ElectronicScaleState {
  zeroed: boolean;
  table?: {
    rows: Row[];
  };
  populatedIndices: Record<string, number>;
}

const initialState: ElectronicScaleState = {
  zeroed: false,
  populatedIndices: {},
};

const electronicScaleSlice = createSlice({
  name: "electronicScaleModal",
  initialState,
  reducers: {
    initTable(state, action: PayloadAction<Table>) {
      state.table = action.payload;
      return state;
    },
    zeroAction(state) {
      return state;
    },
    recordAction(
      state,
      {
        payload: { row, column, value },
      }: PayloadAction<{ row: number; column: number; value: number }>
    ) {
      state.populatedIndices = {
        ...state.populatedIndices,
        [`${row}_${column}`]: value,
      };
      return state;
    },
  },
});

export const useElectronicBalance = (dispatch: Dispatch) => ({
  state: useSelector(electronicScaleSlice.selectSlice),
  actions: bindActionCreators(electronicScaleSlice.actions, dispatch),
});

export const recordQuestionTableCellChange =
  (
    dispatch: Dispatch,
    getState: () => {
      electronicScaleModal: ElectronicScaleState;
      simulation: {
        scaleWeight: number;
      };
    }
  ) =>
  (
    componentID: number,
    row: number,
    column: number,
    linkedRow?: number,
    linkedColumn?: number
  ) => {
    dispatch(
      electronicScaleSlice.actions.recordAction({
        row,
        column,
        value: getState().simulation.scaleWeight,
      })
    );
    if (row && column) {
      dispatch(
        questionTableCellChange({
          value: `${getState().simulation.scaleWeight.toFixed(2)} g`,
          answer: `${getState().simulation.scaleWeight.toFixed(2)} g`,
          id: `${linkedRow}_${linkedColumn}`,
          componentID,
          disabled: true,
        })
      );
      if (linkedRow == 2) {
        const correctDifference =
          getState().simulation.scaleWeight -
          getState().electronicScaleModal.populatedIndices[`${row}_${1}`];

        const incorrectSum =
          getState().simulation.scaleWeight +
          getState().electronicScaleModal.populatedIndices[`${row}_${1}`];

        const incorrectDifference =
          getState().electronicScaleModal.populatedIndices[`${row}_${1}`] -
          getState().simulation.scaleWeight;

        dispatch(
          questionTableCellChange({
            answer: correctDifference.toFixed(2),
            id: `${3}_${linkedColumn}`,
            componentID,
            options: [
              {
                optionID: 1,
                value: (incorrectDifference != 0
                  ? incorrectDifference
                  : -0.95
                ).toFixed(2),
                label: `${(incorrectDifference ? incorrectDifference : -0.95).toFixed(2)} g`,
              },
              {
                optionID: 2,
                value: correctDifference.toFixed(2),
                label: `${correctDifference.toFixed(2)} g`,
              },
              {
                optionID: 3,
                value: incorrectSum.toFixed(2),
                label: `${incorrectSum.toFixed(2)} g`,
              },
            ],
          })
        );
      }
    }
  };

export const {
  actions: { zeroAction, recordAction, initTable },
  reducer: ElectronicScaleModalReducer,
} = electronicScaleSlice;
